// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'credit-solid';

export const Component = () => (
  <path d='M23.037 2H1.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 0 3.485v16.667c0 .43.144.766.431 1.053.288.288.623.432 1.054.432h21.552c.431 0 .766-.144 1.054-.432.287-.287.43-.622.43-1.053V3.485a1.41 1.41 0 0 0-.43-1.054A1.408 1.408 0 0 0 23.037 2ZM7.376 17.71H3.448c-.335 0-.526-.192-.526-.527s.191-.48.526-.48h3.928c.335 0 .479.145.479.48 0 .335-.144.526-.48.526ZM23.563 6.884v2.97H.958v-2.97h22.605Z' />
);

export const viewBox = '0 0 25 25';
